<template>
    <div class="single--select">
         <Select
            :options="options"
            optionLabel="name"
            aria-placeholder="Bitte wählen ..."
            placeholder="Bitte wählen ..."
            :name="`${step.name}[${data.element_details.name}]`"
            v-model="field.value"
            optionValue="id"
         />
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    data: Object,
    field: Object,
    step: Object,
});

const emit = defineEmits(['update:modelValue', 'update:slideForward']);

const options = computed(() => {
    return props.data.valueOptions.map(op => ({
        name: op.label,
        id: op.value
    }));
});


function handleSelect(val) {
    emit('update:modelValue', val ?? '');
    if (!!props.data.jump) {
        emit('update:slideForward');
    }
}
</script>